// Environment configuration using Vite's built-in env support
interface AppConfig {
  API_URL: string;
  APP_TITLE: string;
  NODE_ENV: string;
}

// Vite automatically loads .env files and exposes VITE_ prefixed variables
export const config: AppConfig = {
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:1338/api',
  APP_TITLE: import.meta.env.VITE_APP_TITLE || 'TAIDEKANSALLISPUISTO',
  NODE_ENV: import.meta.env.MODE || 'development'
};

// Helper to check if we're in development
export const isDev = config.NODE_ENV === 'development';

// Helper for logging (only in development)
export const devLog = (...args: any[]) => {
  if (isDev) {
    console.log('[DEV]', ...args);
  }
};

export default config;